// extracted by mini-css-extract-plugin
export default {"container":"vPQ9S5","participantInfo":"pxsm53","nameContainer":"j1yFwy","name":"B4ciP0","label":"Q08kQe","reaction":"gFBDxE","mic":"ireVrh","icons":"sM5RMP"};